// extracted by mini-css-extract-plugin
export default {"pagination":"style_pagination__QslsE","active":"style_active__br6fy"};